export const LINK_CONDITION_TASKS_FORM_ID = 'link-condition-tasks-form';
